import { useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { getVehiclesByVin } from 'app/vehicles/state/actions'
import { Timing } from '@cbgms/base/utils/timing'
import { useDebouncedCallback } from 'use-debounce'
import { EmptyUUID } from '@cbgms/base/utils/uuid'
import {
  duplicateVehicleModalQueryParam,
  duplicateVehicleUUIDQueryParam,
  duplicateVehicleVinQueryParam
} from 'app/vehicles/components/DuplicateVehicleFound/const'
import { useHistory } from 'react-router-dom'

export const useIsDuplicateVIN = (vin: string) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const [duplicateUUID, setDuplicateUUID] = useState(EmptyUUID)

  const showDuplicateVINModal = useCallback(() => {
    const url = new URL(window.location.href)
    url.searchParams.append(duplicateVehicleModalQueryParam, '1')
    url.searchParams.append(duplicateVehicleUUIDQueryParam, duplicateUUID)
    url.searchParams.append(duplicateVehicleVinQueryParam, '1')
    history.replace(url.pathname + url.search)
  }, [duplicateUUID])

  const checkDuplicate = async (vin: string) => {
    const { Data } = await dispatch(getVehiclesByVin(vin))
    if (Data.length) {
      setDuplicateUUID(Data[0].Vehicle.UUID)
    }
  }
  const debouncedCheckDuplicate = useDebouncedCallback(checkDuplicate, Timing.keyboardInput)

  useEffect(() => {
    setDuplicateUUID(EmptyUUID)
    if (!vin || vin.length !== 17) {
      return
    }
    debouncedCheckDuplicate(vin)
  }, [vin])

  return { isDuplicateVIN: duplicateUUID !== EmptyUUID, showDuplicateVINModal }
}
